import { AppRoutes } from 'frontStaticAppPath/lib/types';

import PageUrl from 'src/constants/url';
import ApplicantsActivity from 'src/pages/ApplicantsActivity';
import BrandedVacancies from 'src/pages/BrandedVacancies';
import CallTracking from 'src/pages/CallTracking';
import CompetitorAnalysis from 'src/pages/CompetitorAnalysis';
import CompetitorAnalysisForVacancy from 'src/pages/CompetitorAnalysisForVacancy';
import CompetitorAnalysisReport from 'src/pages/CompetitorAnalysisReport';
import ContactsEfficiency from 'src/pages/ContactsEfficiency';
import HiringCost from 'src/pages/HiringCost';
import Index from 'src/pages/Index';
import Managers from 'src/pages/Managers';
import PolitenessIndex from 'src/pages/PolitenessIndex';
import PolitenessIndexByManagers from 'src/pages/PolitenessIndexByManagers';
import PublicationsEfficiency from 'src/pages/PublicationsEfficiency';
import Vacancies from 'src/pages/Vacancies';
import VacanciesEfficiency from 'src/pages/VacanciesEfficiency';
import VacanciesParameters from 'src/pages/VacanciesParameters';
import VacancyConversion from 'src/pages/VacancyConversion';

const routes = [
    {
        path: PageUrl.Index,
        component: Index,
    },
    {
        path: PageUrl.HiringCost,
        component: HiringCost,
    },
    {
        path: PageUrl.VacanciesEfficiency,
        component: VacanciesEfficiency,
    },
    {
        path: PageUrl.Vacancies,
        component: Vacancies,
    },
    {
        path: PageUrl.Managers,
        component: Managers,
    },
    {
        path: PageUrl.VacanciesParameters,
        component: VacanciesParameters,
    },
    {
        path: PageUrl.PolitenessIndex,
        component: PolitenessIndex,
    },
    {
        path: PageUrl.PolitenessIndexByManagers,
        component: PolitenessIndexByManagers,
    },
    {
        path: PageUrl.ApplicantsActivity,
        component: ApplicantsActivity,
    },
    {
        path: PageUrl.CompetitorAnalysis,
        component: CompetitorAnalysis,
    },
    {
        path: PageUrl.CompetitorAnalysisReport,
        component: CompetitorAnalysisReport,
    },
    {
        path: PageUrl.CompetitorAnalysisForVacancy,
        component: CompetitorAnalysisForVacancy,
    },
    {
        path: PageUrl.BrandedVacancies,
        component: BrandedVacancies,
    },
    {
        path: PageUrl.ContactsEfficiency,
        component: ContactsEfficiency,
    },
    {
        path: PageUrl.PublicationsEfficiency,
        component: PublicationsEfficiency,
    },
    {
        path: PageUrl.CallTracking,
        component: CallTracking,
    },
    {
        path: PageUrl.VacancyConversion,
        component: VacancyConversion,
    },
];

export default routes as AppRoutes;
